import { render, staticRenderFns } from "./UploadOtherFiles.vue?vue&type=template&id=55148322"
import script from "./UploadOtherFiles.vue?vue&type=script&lang=js"
export * from "./UploadOtherFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports